import { render, staticRenderFns } from "./BaseWarning.vue?vue&type=template&id=0751b6cd&"
import script from "./BaseWarning.vue?vue&type=script&lang=js&"
export * from "./BaseWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports